<template>
    <div v-if="!isLoading">
        <app-gridview v-bind:parentData="{
            pageTitle: this.pageTitle,
            tabHeaders: this.dataHeader,
            tabItems: this.dataItems,
            isDelete: true,
        }" v-on:EditItem="editItemHandler($event)" v-on:NewPressed="newRecordHandler"
            v-on:DeleteItem="deleteItemHandler($event)">
        </app-gridview>
        <div v-if="isConfirm">
            <app-confirm v-bind:parentObject="{
                messageConfirm: this.messageConfirm,
                isConfirm: this.isConfirm,
            }" v-on:confirm="deleteItemHandlerAction" v-on:cancelConfirm="isConfirm = !isConfirm" />
        </div>
        <div v-if="isErr">
            <app-error v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
            }" v-on:closeError="isErr = $event" />
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import GridView from "../../../components/common/GridView";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
    components: {
        "app-gridview": GridView,
        "app-error": ErrorDialog,
        "app-confirm": ConfirmDialog,
    },

    data() {
        return {
            pageTitle: this.$t('acknowledgement.title'),
            dataHeader: [
                { text: this.$t('columns.actions'), value: "action", sortable: false, width: "80px" },
                { text: this.$t('acknowledgement.acknowledgementtype'), value: "ackTypeName", sortable: false, width: "auto" },
                { text: this.$t('acknowledgement.acknowledgementname'), value: "ackName", sortable: false, width: "auto" },
                { text: this.$t('acknowledgement.acknowledgementlongdesc'), value: "ackLongDesc", sortable: false, width: "300px" },
                { text: this.$t('acknowledgement.createdate'), value: "createDate", sortable: false, width: "auto" },
                { text: this.$t('acknowledgement.publishdate'), value: "publishDate", sortable: false, width: "auto" },
                { text: this.$t('columns.remark'), value: "remark", sortable: false, width: "auto" },
                { text: this.$t('acknowledgement.suspend'), value: "suspendStatusCode", sortable: false, width: "auto" },
            ],
            dataItems: [],
            isLoading: false,
            errMsg: "",
            isErr: false,

            isConfirm: false,
            messageConfirm: '',
            selectedItem: null,
        };
    },

    methods: {
        async getAcknowledgementRecordHandler() {
            const vm = this;
            try {
                const res = await this.$store.dispatch('get', { url: "/acknowledgements/all" });
                vm.dataItems = res.data.rec;

                for (let i = 0; i < vm.dataItems.length; i++) {

                    if (vm.dataItems[i].createDate) {
                        vm.dataItems[i].createDate = moment(vm.dataItems[i].createDate).format('YYYY-MM-DD');
                    }

                    if (vm.dataItems[i].publishDate) {
                        vm.dataItems[i].publishDate = moment(vm.dataItems[i].publishDate).format('YYYY-MM-DD');
                    }

                    if (vm.dataItems[i].suspendStatus === 1) {
                        vm.dataItems[i].suspendStatusCode = vm.$t('claimmessagemobile.yes');
                    } else {
                        vm.dataItems[i].suspendStatusCode = vm.$t('claimmessagemobile.no');
                    }
                }
            } catch (error) {
                vm.isErr = true;
                vm.errMsg = error;
                console.error("Error fetching acknowledgement records:", error);
            }
        },

        newRecordHandler() {
            this.$router.push({ name: "acknowledgementnew" });
        },

        // advanceEditItemHandler(item) {
        //     this.$router.push({
        //         name: "performanceassessmentrecordstaff",
        //         params: { id: item.id },
        //     });
        // },

        editItemHandler(item) {
            this.$router.push({ name: "acknowledgementedit", params: { id: item.id } });
        },

        deleteItemHandler(item) {
            this.messageConfirm = this.$t('acknowledgement.confirmdeleteacknowledgement', { name: item.ackName });
            this.selectedItem = item;
            this.isConfirm = true;
        },

        deleteItemHandlerAction() {
            const vm = this;

            if (!this.selectedItem) {
                this.isErr = true;
                this.errMsg = " No item selected for deletion!";
                console.error(" No item selected for deletion!");
                return;
            }
            const deleteUrl = "/acknowledgement/" + vm.selectedItem.id + '/' + this.$store.getters.userId;

            if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
                return false;
            }
            this.$store.dispatch('delete', { url: deleteUrl })
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = !vm.isErr;
                        vm.errMsg = res.data.error;
                    } else {
                        window.location.reload();
                    }
                })
                .catch((err) => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                });
            vm.selectedItem = null; // 🔹 Clear after deletion
            this.isConfirm = false;  // 🔹 Close confirmation dialog
        },
    },

    async mounted() {
        this.isLoading = true;
        await this.getAcknowledgementRecordHandler();
        this.isLoading = false;
    },
};
</script>